// extracted by mini-css-extract-plugin
module.exports = {"button":"Login_button__2pF33","social":"Login_social__3-DZO","formbackground":"Login_formbackground__2O8EI"};